"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsteroidMining = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var Resources_1 = require("../../Resources");
var Tags_1 = require("../../cards/Tags");
var AsteroidMining = (function () {
    function AsteroidMining() {
        this.name = GlobalEventName_1.GlobalEventName.ASTEROID_MINING;
        this.description = 'Gain 1 titanium for each Jovian tag (max 5) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.REDS;
        this.currentDelegate = PartyName_1.PartyName.UNITY;
    }
    AsteroidMining.prototype.resolve = function (game, turmoil) {
        var _this = this;
        game.getPlayers().forEach(function (player) {
            player.addResource(Resources_1.Resources.TITANIUM, Math.min(5, player.getTagCount(Tags_1.Tags.JOVIAN, false, false)) + turmoil.getPlayerInfluence(player), { log: true, from: _this.name });
        });
    };
    return AsteroidMining;
}());
exports.AsteroidMining = AsteroidMining;
//# sourceMappingURL=AsteroidMining.js.map